import React, {useState} from 'react';
import {
    Box,
    Flex,
    FormControl,
    IconButton,
    Input,
    InputGroup,
    InputRightElement,
    Link,
    SimpleGrid,
    Spinner,
    Stack,
    Text,
} from '@chakra-ui/react';
import RightAnchorImg from '../../assets/images/right-anchor.svg';
import FooterContainer from './container';
import linksOption, {socialMediaOption} from '../../constants/links';
import {Link as RouterLink,useNavigate} from 'react-router-dom';
import axios from "axios";

const addressOptions = [
    {
        title: 'Silicon Valley',
        address: '3340 Hillview Avenue,<br />Palo Alto, California 94304',
        phone: '650.561.9580',
        timeZone: 'America/Los_Angeles'
    },
    {
        title: 'New York',
        address: '7 Bryant Park, 23rd Floor<br />New York, NY 10018',
        phone: '212.444.4100',
        timeZone: 'America/New_York'
    }
    /*,
    {
        title: 'Boston',
        address: '34 Farnsworth St, 3rd Floor, Boston, MA 02210',
        phone: '617.995.2000',
        timeZone: 'America/New_York'
    },
    */
];

const RightAnchorSvg = () => {
    return <img src={RightAnchorImg} alt="signup to newsletter"/>;
};

const getFormattedTimesForLocations = (options) => {
    return options.map((opt) => {
        const time = new Date(new Date().toLocaleString("en-US", {timeZone: opt.timeZone}));
        const formattedTime = time.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        })
        return {
            ...opt,
            formattedTime
        }
    })
}

let footerInterval = null;

const Footer = () => {
    const [submitted, setSubmitted] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [locations, setLocations] = useState(getFormattedTimesForLocations(addressOptions))

    const navigate = useNavigate();

    if(!footerInterval){
        // console.log('about to set interval on footer');
        footerInterval = setInterval(() => {
            setLocations(getFormattedTimesForLocations(addressOptions))
        }, 10 * 1000)
    }
    return (
        <>
            <FooterContainer>
                <Stack
                    direction={{base: 'column-reverse', lg: 'row'}}
                    justify="space-between"
                    textAlign="left"
                >
                    <SimpleGrid
                        columns={[1, 3]}
                        order={[1, 'unset']}
                        gap={['40px', '127px']}
                        width={{base: 'full', lg: 'auto'}}
                        mb={['60px', 0]}
                    >
                        {locations.map((item, idx) => {
                            return (
                                <Box maxW={'300'} key={idx} my={{base: '50px', lg: '0'}}>
                                    <Text
                                        textColor={'white'}
                                        fontSize={'md'}
                                        fontWeight={'semibold'}
                                        lineHeight={'6'}
                                    >
                                        {item.title}
                                    </Text>
                                    <Text
                                        textColor={'white'}
                                        fontSize={'md'}
                                        fontWeight={'semibold'}
                                        lineHeight={'6'}
                                    >
                                        {item.formattedTime}
                                    </Text>
                                    <Text
                                        textColor={'white'}
                                        fontSize={'md'}
                                        fontWeight={'light'}
                                        lineHeight={'6'}
                                        dangerouslySetInnerHTML={{
                                            __html: item.address,
                                        }}
                                    />
                                    <Box mt={'5'}>
                                        <Text
                                            textColor={'whiteAlpha.600'}
                                            fontSize={'xs'}
                                            fontWeight={'light'}
                                            lineHeight={'10px'}
                                            textTransform={'uppercase'}
                                        >
                                            phone
                                        </Text>
                                        <Text
                                            textColor={'white'}
                                            fontSize={'md'}
                                            fontWeight={'light'}
                                            lineHeight={'6'}
                                        >
                                            {item.phone}
                                        </Text>
                                    </Box>
                                </Box>
                            )
                        })}
                    </SimpleGrid>
                    <Stack
                        spacing={0}
                        sx={{
                            '& a:not(:last-child)': {
                                mb: '1.25rem !important',
                            },
                            mr: ['0.7rem !important', '3.7rem !important'],
                        }}
                        direction={'column'}
                    >
                        {linksOption.map((item, idx) => { 
                            /*
                                to={item.external ? undefined : item.href}
                                href={item.external ? item.href : undefined}
                            */
                            return (
                            <Link
                                fontWeight={'semibold'}
                                lineHeight={'3rem'}
                                letterSpacing={'-1px'}
                                to={item.external ? undefined : item.href}
                                href={item.external ? item.href : undefined}
                                fontSize={'5xl'}
                                key={idx} 
                                isExternal={item.external}
                                as={item.external ? undefined : RouterLink}
                                state={{comingFrom: "footer"}}
                                onClick={() => {
                                    if(item.href == '/team') {
                                        window.sessionStorage.setItem("teamscroll", 0);
                                    }
                                    /*
                                    if(item.href == '/podcasts/running-through-walls') {
                                        document.location = '/podcasts/running-through-walls';
                                    }
                                    */
                                }}
                            >
                                {item.title}
                            </Link>
                        )})}
                    </Stack>
                </Stack>
                <Box mt={['60px', 0]} mb={['5.25rem', '3.75rem']} textAlign="left">
                    <Box
                        display={'inline-block'}
                        width={'100%'}
                        maxW={'483px'}
                        as="label"
                        htmlFor={'newsLetter'}
                    >
                        {!submitted &&
                            <>
                                <Text
                                    as={'span'}
                                    mb={'20px'}
                                    color={'white'}
                                    lineHeight={'6'}
                                    fontSize={'md'}
                                >
                                    Sign up for our newsletter
                                </Text>
                                <form onSubmit={async (e) => {
                                    setIsLoading(true)
                                    e.preventDefault()
                                    const form = new FormData(e.target);
                                    const email = form.get("email");

                                    await axios({
                                        url: '/wp-admin/admin-ajax.php?action=add-contact&email='+ encodeURIComponent( email), 
                                        method: 'get',
                                        }).then((res) => {
                                            setIsLoading(false)
                                            setSubmitted(true)
                                        }).catch((error) => {
                                            setIsLoading(false)
                                            console.error(error);
                                        });

                                }}>
                                    <FormControl>
                                        <InputGroup size={'xl'} w={'100%'} bg={'transparent'}>
                                            <Input
                                                _placeholder={{
                                                    lineHeight: '15px',
                                                    fontSize: 'sm',
                                                    textColor: 'whiteAlpha.600',
                                                }}
                                                _focus={{
                                                    background: 'transparent'
                                                }}
                                                sx={{
                                                    bg: 'transparent !important'
                                                }}
                                                backgroundColor={'transparent'}
                                                bg={'transparent'}
                                                id={'newsLetter'}
                                                variant="flushed"
                                                name='email'
                                                pl={2}
                                                placeholder="Enter your email address"
                                            />
                                            <InputRightElement
                                                children={<IconButton aria-label='newsletter-submit' type='submit'
                                                                      icon={isLoading ? <Spinner color='white'/> :
                                                                          <RightAnchorSvg/>}/>}
                                                _hover={{cursor: 'pointer'}}/>
                                        </InputGroup>
                                    </FormControl>
                                </form>
                            </>
                        }
                        {submitted && <Text
                            as={'span'}
                            mb={'20px'}
                            color={'white'}
                            lineHeight={'6'}
                            fontSize={'md'}
                        >
                            Thanks for signing up!
                        </Text>}
                    </Box>
                </Box>
                <Flex
                    justifyContent={'space-between'}
                    flexDirection={{base: 'column', md:'row'}}
                    alignItems={{base: 'start', md:'end'}}
                >
                    <Text color={'white'} lineHeight={'6'} fontSize={'md'} display={{base: 'none', md:'block'}}>
                        © {new Date().getFullYear()} Venrock&nbsp;&nbsp;|&nbsp;&nbsp;<Link href="/privacy-policy" display={"inline-block"}>Privacy Policy</Link>
                    </Text>
                    <Flex 
                        justifyContent={'space-between'}
                        flexDirection={{base: 'column', md:'row'}}
                        alignItems={{base: 'start', md:'end'}}
                    >
                        {/*}
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            width={{base: 'auto', sm: '33%', lg: '256px'}}
                            textAlign={'left'}
                            mr={['0', '3.7rem']}
                        >
                            
                            <Text
                                textColor={'whiteAlpha.600'}
                                fontSize={'xs'}
                                fontWeight={'semibold'}
                                lineHeight={'10px'}
                                textTransform={'uppercase'}
                                mb={'2'}
                            >
                                follow us
                            </Text>
                            {socialMediaOption.map((item, idx, key) => {
                                return (
                                    <Link
                                        href={item.href}
                                        textColor={'white'}
                                        fontSize={'md'}
                                        fontWeight={'semibold'}
                                        lineHeight={'6'}
                                        key={idx}
                                    >
                                        {item.title}
                                    </Link>
                                );
                            })}
                        
                        </Box>
                        */}
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            width={['auto', '256px']}
                            textAlign={'left'}
                            mr={['0', '3.7rem']}
                            mt={{base: '20px', md: '0'}}
                        >
                            <Text
                                textColor={'whiteAlpha.600'}
                                fontSize={'xs'}
                                fontWeight={'semibold'}
                                lineHeight={'10px'}
                                textTransform={'uppercase'}
                                mb={'2'}
                            >
                                follow us
                            </Text>
                            {socialMediaOption.map((item, idx, key) => {
                                return (
                                    <Link
                                        href={item.href}
                                        textColor={'white'}
                                        fontSize={'md'}
                                        fontWeight={'semibold'}
                                        lineHeight={'6'}
                                        key={idx}
                                    >
                                        {item.title}
                                    </Link>
                                );
                            })}
                            <Text
                                textColor={'whiteAlpha.600'}
                                fontSize={'xs'}
                                fontWeight={'semibold'}
                                lineHeight={'10px'}
                                textTransform={'uppercase'}
                                mb={'2'}
                                mt={'4'}
                            >
                                visit
                            </Text>
                            <Box
                                display={'flex'}
                                flexDirection={'column'}
                                width={['auto', '256px']}
                                textAlign={'left'}
                                mr={['0', '3.7rem']}
                            >
                                <Link
                                    href={'https://venrockcp.com'}
                                    textColor={'white'}
                                    fontSize={'md'}
                                    fontWeight={'semibold'}
                                    lineHeight={'6'}
                                >
                                    Crossover / Public Healthcare
                                </Link>
                                <Link
                                    href={'https://icx.efrontcloud.com/Venrock/login.aspx'}
                                    textColor={'white'}
                                    fontSize={'md'}
                                    fontWeight={'semibold'}
                                    lineHeight={'6'}
                                >
                                    LP Login
                                </Link>
                            </Box>
                        </Box>
                    </Flex>
                    <Text color={'white'} lineHeight={'6'} fontSize={'md'} display={{base: 'block', md:'none'}} mt={{base: '20px', md:'0'}}>
                        © 2022 Venrock&nbsp;&nbsp;|&nbsp;&nbsp;<Link href="/privacy-policy" display={"inline-block"}>Privacy Policy</Link>
                    </Text>
                </Flex>
            </FooterContainer>
        </>
    );
};

export default Footer;

Footer.displayName = 'companies-overview__footer';
